import { getPaths } from "lib/utils/paths";

export const persistFormData = (formData: any) => {
  // eslint-disable-next-line i18next/no-literal-string
  localStorage.setItem("pending_form_data", JSON.stringify(formData));
};

export const getPendingFormData = (fallbackLang: string) => {
  const storageValue = localStorage.getItem("pending_form_data");
  if (!storageValue) return { email_language: fallbackLang };
  const pendingData = JSON.parse(storageValue || "");
  if (typeof pendingData === "object") return pendingData;
  return { email_language: fallbackLang };
};

class RegisterController {
  static async onSubmitStepOne(
    formData: any,
    push: (url: string, p: undefined, opt: object) => void,
  ) {
    push(
      getPaths.register.athlete.step(2),
      undefined,
      { shallow: true }
    );
    return;
  }

  static async onSubmitStepTwo(
    formData: any,
    push: (url: string, p: undefined, opt: object) => void,
  ) {
    push(
      getPaths.register.athlete.step(3),
      undefined,
      { shallow: true }
    );
    return;
  }

  static async onSubmitStepThree(
    formData: any,
    push: (url: string, p: undefined, opt: object) => void,
  ) {
    push(
      getPaths.register.athlete.step(4),
      undefined,
      { shallow: true }
    );
    return;
  }

  static async onSubmitStepFour(
    formData: any,
    push: (url: string, p: undefined, opt: object) => void,
  ) {
    persistFormData(formData);
    push(
      getPaths.register.athlete.step(5),
      undefined,
      { shallow: true }
    );
    return;
  }
}

export default RegisterController;
